import { gql } from 'graphql-request';

/**
 * GraphQL mutation for updating a page
 */
export const updatePageMutation = gql`
  mutation UpdatePage($id: ID!, $input: PageUpdateInput!) {
    updatePage(id: $id, input: $input) {
      id
      subslug
      pricing_page_url
      archived
      created_at
    }
  }
`;

/**
 * Type for the update page input
 */
export interface UpdatePageInput {
  subslug?: string;
  pricing_page_url?: string;
  archived?: boolean;
}

/**
 * Type for the update page response
 */
export interface UpdatePageResponse {
  updatePage: {
    id: string;
    subslug?: string;
    pricing_page_url?: string;
    archived?: boolean;
    created_at?: string;
  };
}